import {
    Card, Col, Row,
    Statistic,
    Typography,
    useTable
} from '@pankod/refine-antd';
import React, {useEffect, useState} from 'react';
import {IResourceComponentsProps} from '@pankod/refine-core';
import "./style.css";
import dayjs from 'dayjs';
const { Meta } = Card;
const { Title } = Typography;
export const MonitorList: React.FC<IResourceComponentsProps> = () => {

    const [i, setI] = useState(0);
    const [ncard, setNcard] = useState(6);
    const [totCard, setTotCard] = useState(0);

    const {tableQueryResult, tableProps} =  useTable<any>({
        resource: 'servers',
        hasPagination: false
    })

    useEffect(() => {
        setTotCard(Number(tableQueryResult.data?.data.length));
        setInterval(() => {
            // setI(i+ncard+1);
            // if (i > totCard) {
            //     setI(1);
            // }
            // setTimeout(() => {
                tableQueryResult.refetch();
            // }, 500)
        }, 10000)
    }, [])


    return (
        <>
            <div style={{display: 'flex', flexFlow: 'row wrap', padding: '5px 5px 5px 5px'}}>
            {tableQueryResult.data?.data.map((s: any, i: any) => {
                const oggi = new Date();
                const d = new Date(s.ultimo_contatto);
                const difference = oggi.getTime() - d.getTime();
                const resultInMinutes = Math.round(difference / 60000);
                return (
                            <Card
                                hoverable
                                style={{width: 300, marginRight: 10, marginBottom: 5}}
                            >
                                <Row gutter={24}  align={'middle'}>
                                    <Col span={24} style={{ textAlign: 'center' }}>
                                        <Title level={2} style={{ textAlign: 'center', fontSize: 24, color: '#ffac00'}}>{s.nome}</Title>
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={8} style={{ textAlign: 'center' }}>
                                        <Title level={4} >CPU</Title>
                                    </Col>
                                    <Col span={8} style={{ textAlign: 'center' }}>
                                        <Title level={4} >DSK</Title>
                                    </Col>
                                    <Col span={8} style={{ textAlign: 'center' }}>
                                        <Title level={4} >MEM</Title>
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={8} style={{ textAlign: 'center', fontSize: 30, fontWeight: 700,
                                        color: (s.cpu >= 95 && s.tempoTrascorso > 10) ? '#800100' : '#d0ad01' }}>
                                        {parseFloat(s.cpu.toString()).toFixed(0)}
                                    </Col>
                                    <Col span={8} style={{ textAlign: 'center', fontSize: 30, fontWeight: 700,
                                        color: (s.cpu >= 95 && s.tempoTrascorso > 10) ? '#800100' : '#d0ad01' }}>
                                        {parseFloat(s.disk.toString()).toFixed(0)}
                                    </Col>
                                    <Col span={8} style={{ textAlign: 'center', fontSize: 30, fontWeight: 700,
                                        color: (s.cpu >= 95 && s.tempoTrascorso > 10) ? '#800100' : '#d0ad01', }}>
                                        {parseFloat(s.mem.toString()).toFixed(0)}
                                    </Col>
                                </Row>
                                <Row gutter={24} align={'middle'}>
                                    <Col span={24} style={{ textAlign: 'center', fontSize: 18,
                                        color: (s.cpu >= 95 && s.tempoTrascorso > 10) ? '#800100' : '#d0ad01', }}>
                                        <Title level={2} style={{ textAlign: 'center', fontSize: 14}}>{dayjs(s.ultimo_contatto).format('DD/MM/YYYY')}</Title>
                                    </Col>
                                </Row>
                                <Row gutter={24} align={'middle'}>
                                    <Col span={24} style={{ textAlign: 'center'}}>
                                        <Title level={2} style={{ textAlign: 'center', fontSize: 24}}>{dayjs(s.ultimo_contatto).format('HH:mm:ss')}</Title>
                                    </Col>
                                </Row>
                                {/*<Statistic title={<Title type={'warning'} level={1}*/}
                                {/*                         style={{textAlign: 'center'}}>{s.nome}</Title>}*/}
                                {/*           valueStyle={{*/}
                                {/*               fontSize: 40,*/}
                                {/*               color: (s.cpu >= 95 && s.tempoTrascorso > 10) ? '#800100' : '#d0ad01',*/}
                                {/*               textAlign: 'center'*/}
                                {/*           }}*/}
                                {/*           value={parseFloat(s.cpu.toString()).toFixed(0)} prefix={<Title level={5}>CPU:</Title>} suffix={''}/>*/}
                                {/*<Statistic title={''} valueStyle={{*/}
                                {/*    fontSize: 40,*/}
                                {/*    color: s.disk >= 90 ? '#800100' : '#d0ad01',*/}
                                {/*    textAlign: 'center'*/}
                                {/*}}*/}
                                {/*           value={parseFloat(s.disk.toString()).toFixed(0)} prefix={<Title level={5}>Disk:</Title>} suffix={''}/>*/}
                                {/*<Statistic title={''} valueStyle={{*/}
                                {/*    fontSize: 40,*/}
                                {/*    color: (s.mem >= 95 && s.tempoTrascorso > 10) ? '#800100' : '#d0ad01',*/}
                                {/*    textAlign: 'center'*/}
                                {/*}}*/}
                                {/*           value={parseFloat(s.mem.toString()).toFixed(0)} prefix={<Title level={5}>Memoria:</Title>} suffix={''}/>*/}
                                {/*<Statistic title={''} valueStyle={{*/}
                                {/*    fontSize: 18,*/}
                                {/*    color: resultInMinutes >= 5 ? '#800100' : '#d0ad01',*/}
                                {/*    textAlign: 'center'*/}
                                {/*}}*/}
                                {/*           value={dayjs(s.ultimo_contatto).format('DD/MM/YYYY HH:MM:ss')}*/}
                                {/*           prefix={''} suffix={''}/>*/}
                            </Card>

                )
            }

            )}
            </div>
        </>
    );
};
